import { render, staticRenderFns } from "./client-board-dynamic-loader.vue?vue&type=template&id=0d8a39c1"
import script from "./client-board-dynamic-loader.vue?vue&type=script&lang=js"
export * from "./client-board-dynamic-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports